/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IPasswordResetLoadingIcon {
    className: string;
}

const PasswordResetLoadingIcon: React.FC<IPasswordResetLoadingIcon> = ({ className }) => (
    <div className={`${className}__loading-icon`} />
);

export default PasswordResetLoadingIcon;
